"use strict";
/**
  * @reach/window-size v0.18.0
  *
  * Copyright (c) 2018-2022, React Training LLC
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE.md file in the root directory of this source tree.
  *
  * @license MIT
  */


// src/reach-window-size.tsx
import * as React from "react";
import {
  canUseDOM,
  useIsomorphicLayoutEffect as useLayoutEffect
} from "@reach/utils";
var WindowSize = ({ children }) => {
  const dimensions = useWindowSize();
  return children(dimensions);
};
WindowSize.displayName = "WindowSize";
function useWindowSize() {
  let { current: hasWindow } = React.useRef(canUseDOM());
  const [dimensions, setDimensions] = React.useState({
    width: hasWindow ? window.innerWidth : 0,
    height: hasWindow ? window.innerHeight : 0
  });
  useLayoutEffect(() => {
    const resize = () => setDimensions({
      width: window.innerWidth,
      height: window.innerHeight
    });
    window.addEventListener("resize", resize);
    return () => window.removeEventListener("resize", resize);
  }, []);
  return dimensions;
}
export {
  WindowSize,
  useWindowSize
};
